import imageSpecs from "imageSpecs.json";

/**
 * Given the original image path and a size string, returns a path to the sized
 * variant of the given image.
 *
 * @param imagePath path to the original image.
 * @param size size string (key of imageSpecs.sizes)
 * @param ext image extension. Defaults to original.
 */
export const getImageSize = (
  imagePath: string,
  size: keyof typeof imageSpecs.sizes,
  ext?: typeof imageSpecs.formats[number]
): string => {
  return imagePath.replace(
    /\.([a-zA-Z0-9])+$/,
    (currentExt) => `.${size}.${ext ?? currentExt}`
  );
};
